import { useCallback, useEffect, useMemo, useState } from 'react'

const useWindowSize = () => {
  const [windowWidth, setWindowWidth] = useState()
  const [windowHeigh, setWindowHeight] = useState()

  const windowSize = useMemo(
    () => ({ height: windowHeigh, width: windowWidth }),
    [windowHeigh, windowWidth],
  )

  const handleResize = useCallback(() => {
    setWindowWidth(window.innerWidth)
    setWindowHeight(window.innerHeight)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [handleResize])

  return windowSize
}

export default useWindowSize
